module.exports = __webpack_public_path__ + "static/media/et.4e95cb38.svg";